import React from 'react';

const SelectList = (props) => {
    let cssClass = props.cssClass ? props.cssClass : "";
    return (  
    <div className="form-group">
        <div className="col-sm-4">
            <label htmlFor={props.name} className="form-label">{props.title}</label>
            {props.badge ? <span className='badge'>必須</span> : ''}
        </div>
        <div className="col-sm-8 ">
            <div className={cssClass}>
            {Object.keys(props.value).map(item => {
                return (
                    <span key={item}>
                    <select
                        key={item}
                        id={item}
                        name={props.name}
                        value={props.value[item]}
                        onChange={props.handleChange}
                        >
                        <option id="0" value="--" label="--">{'--'}</option>
                        {props.options[item].map(option => {
                            return (
                                <option
                                key={option}
                                id={option}
                                value={option}
                                label={option}>{option}
                                </option>
                            );
                        })}
                    </select>{props.itemsName[item]}</span>
                );
            })}
            </div>
        </div>
    </div>
    )
}

export default SelectList;